module.exports = __webpack_public_path__ + "static/media/androidFullbodyIcon.f8a298c7.png";